<template>
  <!-- New layout -->
  <a :href="url" class="max-w-3xl search-result-item group" ref="searchResultItem">
    <div class="search-result-item-header">
      <ul v-if="breadcrumbs" class="breadcrumbs" role="menu" aria-label="Brödsmulor">
        <li v-for="(crumb, index) in breadcrumbs" :key="index">
          {{ crumb }}
        </li>
      </ul>
      <time v-if="date" :datetime="date" class="search-result-item-date">{{ dateText }}</time>
    </div>

    <div class="search-result-item-link-wrap">
      <h3 v-if="heading" class="search-result-item-heading">{{ heading }}<ellevio-web-link-icon /></h3>
    </div>
    <p v-if="excerpt" class="search-result-item-paragraph">
      {{ excerpt }}
    </p>
  </a>
</template>

<script>
import EllevioWebLinkIcon from '../structure/LinkIcon.vue'

export default {
  name: 'EllevioWebSearchResultItem',
  components: {
    EllevioWebLinkIcon
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: null
    },
    heading: {
      type: String,
      default: ''
    },
    excerpt: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    dateText: {
      type: String,
      default: ''
    },
    existingItemsCount: {
      type: Number
    },
    additionalItemsCount: {
      type: Number
    },
    itemIndex: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    if (this.focusOnFirstLoadedSearchItem) {
      this.$refs.searchResultItem.focus()
    }
  },
  computed: {
    focusOnFirstLoadedSearchItem() {
      return this.existingItemsCount - this.additionalItemsCount * 2 === this.itemIndex
    }
  }
}
</script>
